import type { LinkTarget, Visibility } from "../api/types.gen.ts";

/** Whether it's private: only the people on its list (and admins) see it. */
export const isPrivate = (x: { visibility?: Visibility | null }) => x.visibility === "private";

/** An item's short link, to send someone: it opens the item (in its space) for whoever may see it. */
export const itemLink = (id: string) => `${globalThis.location.origin}/i/${id}`;

/** Where a link leads you: the item in its space, or (its guest) its own page. */
export function itemPath(at: LinkTarget): string {
  return at.guest ? `/g/${at.item}` : `/s/${at.space}/items/${at.item}`;
}
